import Vue from "vue/dist/vue.common";
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import PerfectScrollbar from 'perfect-scrollbar';

export default class RenderedMenu {
	constructor() {
		this.el = document.querySelector('.rendered-menu');
		this.btn = document.querySelector('#buttonOpenDeskMenu');
		this.header = document.querySelector(".main-header");

		if (!this.header && !this.el && !this.btn) return;

		this.dataMenu = [];
		this.initMenu();
		this.initMobileMenu();
		this.requestMenu();

		this.btn.addEventListener('click', (e) => {
			this.openMenu();
		});
	}

	openMenu() {
		if (this.el.classList.contains('is-open')) {
			this.btn.classList.remove('is-opened');
			this.el.classList.remove('is-open');
			enableBodyScroll(document.querySelector('.rendered-menu__wrapper'));

			if (window.pageYOffset < this.header.offsetHeight) {
				this.header.classList.remove('is-fixed')
			}
		} else {
			disableBodyScroll(document.querySelector('.rendered-menu__wrapper'), {
				reserveScrollBarGap: true,
			});
			this.el.classList.add('is-open');
			this.btn.classList.add('is-opened');
			this.header.classList.add('is-fixed')
		}

	}

	initMenu() {
		this.renderedMenu = new Vue({
			el: document.querySelector('.rendered-menu__wrapper'),
			data() {
				return {
					dataMenu: [],
					activeMenuIndex: 0,
					psfl: null,
					pssl: null,
					hover: null
				}
			},
			methods: {
				psupdate() {
					this.psfl.update()
					this.pssl.update()
				},
				hoverfl(menuIndex, event) {
					this.hover = event.target

					setTimeout(() => {
						if (this.hover === event.target) {
							this.activeMenuIndex = menuIndex;
							document.querySelector('.rendered-menu__second-level').scrollTop = 0;
							this.psupdate();
						}
					}, 400)
				}
			},
			mounted() {
				this.psfl = new PerfectScrollbar('.rendered-menu__first-level');
				this.pssl = new PerfectScrollbar('.rendered-menu__second-level');
				this.psupdate();
			}
		})

	}

	initMobileMenu() {
		this.renderedMobileMenu = new Vue({
			el: document.querySelector('#mobilemenu'),
			data() {
				return {
					dataMenu: [],
					$mobileMenu: $("#mobilemenu"),
					$mobileMenuisLeftSide: $("#mobilemenu").hasClass('leftside'),
					$mobileMenuisOpen: $("#mobilemenu").hasClass('show'),
					$mobileMenuisDowndrop: $("#mobilemenu").find('>.scroller').hasClass('downdrop')
				}
			},
			methods: {
				redefinition() {
					this.$mobileMenu = $("#mobilemenu"),
						this.$mobileMenuisLeftSide = $("#mobilemenu").hasClass('leftside'),
						this.$mobileMenuisOpen = $("#mobilemenu").hasClass('show'),
						this.$mobileMenuisDowndrop = $("#mobilemenu").find('>.scroller').hasClass('downdrop')
				},
				OpenMobileMenu() {
					if (!this.$mobileMenuisOpen) {
						// hide styleswitcher
						disableBodyScroll(this.el, {
							reserveScrollBarGap: true,
						});
						if ($('.style-switcher').hasClass('active')) {
							$('.style-switcher .switch').trigger('click')
						}
						$('.style-switcher .switch').hide()

						if (this.$mobileMenuisLeftSide) {
							// show overlay
							setTimeout(() => {
								$('#mobilemenu-overlay').fadeIn('fast')
							}, 100)
						} else {
							// scroll body to top & set fixed
							$('body').scrollTop(0).css({position: 'fixed'})

							// set menu top = bottom of header
							this.$mobileMenu.css({top: +($('#mobileheader').height() + $('#mobileheader').offset().top) + 'px'})

						}

						// show menu
						this.$mobileMenu.addClass('show')
						this.$mobileMenuisOpen = true

						if (!this.$mobileMenuisDowndrop) {
							var $wrap = this.$mobileMenu.find('.wrap').first()
							var params = $wrap.data('params')
							if (typeof params === 'undefined') {
								params = {
									depth: 0,
									scroll: {},
									height: {}
								}
							}
							$wrap.data('params', params)
						}
					}
				},
				CloseMobileMenu() {
					if (this.$mobileMenuisOpen) {
						// hide menu
						this.$mobileMenu.removeClass('show')
						this.$mobileMenuisOpen = false
						// show styleswitcher
						$('.style-switcher .switch').show()

						if (this.$mobileMenuisLeftSide) {
							// hide overlay
							setTimeout(() => {
								$('#mobilemenu-overlay').fadeOut('fast')
							}, 100)
						} else {

							// body unset fixed
							$('body').css({position: 'relative'})
						}

						if (!this.$mobileMenuisDowndrop) {
							setTimeout(() => {
								var $scroller = this.$mobileMenu.find('.scroller').first()
								var $wrap = this.$mobileMenu.find('.wrap').first()
								var params = $wrap.data('params')
								params.depth = 0
								$wrap.data('params', params).attr('style', '')
								this.$mobileMenu.scrollTop(0)
								$scroller.css('height', '')
							}, 400)
						}
						this.$mobileMenu.find('.expanded').removeClass('expanded')
						enableBodyScroll(this.el);
					}
				},
				MoveMobileMenuWrapNext() {
					if (!this.$mobileMenuisDowndrop) {
						var $scroller = this.$mobileMenu.find('.scroller').first()
						var $wrap = this.$mobileMenu.find('.wrap').first()
						if ($wrap.length) {
							var params = $wrap.data('params')
							var $dropdownNext = this.$mobileMenu.find('.expanded>.dropdown').eq(params.depth)
							if ($dropdownNext.length) {
								// save scroll position
								params.scroll[params.depth] = parseInt(this.$mobileMenu.scrollTop())

								// height while move animating
								params.height[params.depth + 1] = Math.max($dropdownNext.height(), (!params.depth ? $wrap.height() : this.$mobileMenu.find('.expanded>.dropdown').eq(params.depth - 1).height()))
								$scroller.css('height', params.height[params.depth + 1] + 'px')

								// inc depth
								++params.depth

								// translateX for move
								$wrap.css('transform', 'translateX(' + -100 * params.depth + '%)')

								// scroll to top
								setTimeout(() => {
									this.$mobileMenu.animate({scrollTop: 0}, 200);
								}, 100)

								// height on enimating end
								var h = $dropdownNext.height()
								setTimeout(function () {
									if (h) {
										$scroller.css('height', h + 'px')
									} else {
										$scroller.css('height', '')
									}
								}, 200)
							}

							$wrap.data('params', params)
						}
					}
				},
				MoveMobileMenuWrapPrev() {
					if (!this.$mobileMenuisDowndrop) {
						var $scroller = this.$mobileMenu.find('.scroller').first()
						var $wrap = this.$mobileMenu.find('.wrap').first()
						if ($wrap.length) {
							var params = $wrap.data('params')
							if (params.depth > 0) {
								var $dropdown = this.$mobileMenu.find('.expanded>.dropdown').eq(params.depth - 1)
								if ($dropdown.length) {
									// height while move animating
									$scroller.css('height', params.height[params.depth] + 'px')

									// dec depth
									--params.depth

									// translateX for move
									$wrap.css('transform', 'translateX(' + -100 * params.depth + '%)')

									// restore scroll position
									setTimeout(() => {
										this.$mobileMenu.animate({scrollTop: params.scroll[params.depth]}, 200);
									}, 100)

									// height on enimating end
									var h = (!params.depth ? false : this.$mobileMenu.find('.expanded>.dropdown').eq(params.depth - 1).height())
									setTimeout(function () {
										if (h) {
											$scroller.css('height', h + 'px')
										} else {
											$scroller.css('height', '')
										}
									}, 200)
								}
							}

							$wrap.data('params', params)
						}
					}
				},
				prevLevel(event) {
					event.preventDefault()
					var $this = $(event.currentTarget)
					this.MoveMobileMenuWrapPrev()
					setTimeout(function () {
						$this.closest('.expanded').removeClass('expanded')
					}, 400)
				},
				nextLevel(event) {
					var $this = $(event.currentTarget)

					if ($this.hasClass('parent')) {
						event.preventDefault()

						if (!this.$mobileMenuisDowndrop) {
							$this.closest('li').addClass('expanded')
							this.MoveMobileMenuWrapNext()
						} else {
							if (!$this.closest('li').hasClass('expanded')) {
								$this.closest('li').addClass('expanded')
							} else {
								$this.closest('li').removeClass('expanded')
							}
						}
					} else {
						if ($this.closest('li').hasClass('counters')) {
							var href = $this.attr('href')
							if (typeof href !== 'undefined') {
								window.location.href = href
								window.location.reload()
							}
						}

						if (!$this.closest('.menu_back').length) {
							document.body.classList.add('is-loading');
							this.CloseMobileMenu()
						}
					}
				},
				initMenu() {
					if (this.$mobileMenu) {
						$('#header .burger').click(() => {
							if (this.$mobileMenuisOpen) {
								this.CloseMobileMenu()
							} else {
								this.OpenMobileMenu()
							}
						})

						if (this.$mobileMenuisLeftSide) {
							this.$mobileMenu.parent().append('<div id="mobilemenu-overlay"></div>')

							$('#mobilemenu-overlay').click(() => {
								if (this.$mobileMenuisOpen) {
									this.CloseMobileMenu()
								}
							});

							$(document).swipeleft((e) => {
								if (!$(e.target).closest('.flexslider').length && !$(e.target).closest('.swipeignore').length) {


									this.CloseMobileMenu()
								}
							});
						} else {
							$('#mobileheader').click((e) => {
								if (!$(e.target).closest('#mobilemenu').length && !$(e.target).closest('.burger').length && this.$mobileMenuisOpen) {
									this.CloseMobileMenu()
								}
							});
						}

						$('#mobilemenu .menu a').click((e) => {
							this.nextLevel(e);
						})

						$('#mobilemenu .dropdown .menu_back').click((e) => {
							this.prevLevel(e);
						})
						$('#mobilemenu .menu_close').click((e) => {
							this.CloseMobileMenu()
						})
					}
				},
				initMobileRegions() {
					$('.mobile_regions .submit-form').on('click', function (e) {
						$(this).closest('form').submit();
						localStorage.removeItem('menu');
						localStorage.removeItem('menulifetime');
					});
				}
			},
			mounted() {
				this.redefinition();
				this.$nextTick(this.initMenu());
				this.$nextTick(this.initMobileRegions());
			},
			update() {
				this.redefinition();
				this.$nextTick(this.initMenu());
				this.$nextTick(this.initMobileRegions());
			}
		})
	}

	requestMenu() {
		if (localStorage.getItem('menu') && localStorage.getItem('menulifetime') && localStorage.getItem('menulifetime') > Date.now()) {
			this.renderedMenu.dataMenu = JSON.parse(localStorage.getItem('menu'));
			this.renderedMobileMenu.dataMenu = JSON.parse(localStorage.getItem('menu'));
		} else {
			$.ajax({
				url: this.header.dataset.menurequest,
				dataType: "json",
				beforeSend: () => {
					this.btn.classList.add('is-loading');
				},
				success: (res) => {
					this.btn.classList.remove('is-loading');
					this.renderedMenu.dataMenu = res.menu;
					this.renderedMobileMenu.dataMenu = res.menu;
					localStorage.setItem('menu', JSON.stringify(res.menu));
					let d = new Date();
					localStorage.setItem('menulifetime', JSON.stringify(d.setDate(d.getDate() + 1)));
				},
				error: (er) => {
					this.btn.classList.remove('is-loading');
					console.error(er);
				}
			});
		}
	}
}
